import React, { FC } from "react";
import { ReactComponent as CloseIcon } from "src/assets/icons/x-mark.svg";
import { ModalState } from "src/hooks/useModal";
import { Button } from "../Button";

interface Props {
  closeModal: ModalState["closeModal"];
}

export const CloseButton: FC<Props> = ({ closeModal }) => (
  <Button
    className="absolute top-2 right-2 opacity-50 hover:opacity-100"
    onClick={closeModal}
  >
    <CloseIcon className="w-6 h-6" />
  </Button>
);
